/*
 * よくある質問 (/pages/question)・お買い物ガイド (/pages/guide) 専用スクリプト
 * 旧サイトから移植されたプレーンな HTML を整形する。
 * 失敗した場合は元の表示のまま（グレースフルデグラデーション）。
 */
(function () {
  'use strict';

  function init() {
    var faqRoot = document.querySelector('.iic-page--question');
    var guideRoot = document.querySelector('.iic-page--guide');
    var tradelawRoot = document.querySelector('.iic-page--tradelaw');

    try {
      if (faqRoot) {
        buildToc(faqRoot);
        buildAccordion(faqRoot);
      }
      if (guideRoot) {
        styleGuideToc(guideRoot);
        buildFeeTable(guideRoot);
      }
      if (tradelawRoot) {
        formatTradelaw(tradelawRoot);
      }
    } catch (e) {
      // 整形に失敗しても元のコンテンツ表示は維持する
      if (window.console && console.warn) console.warn('page-custom-content:', e);
    }
  }

  /* --- FAQ: h2.subtitle から目次を生成 --- */
  function buildToc(root) {
    var headings = root.querySelectorAll('h2.subtitle');
    if (headings.length < 2) return;

    var toc = document.createElement('ul');
    toc.className = 'iic-toc';

    for (var i = 0; i < headings.length; i++) {
      var id = 'faq-section-' + (i + 1);
      headings[i].id = id;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = headings[i].textContent.trim();
      li.appendChild(a);
      toc.appendChild(li);
    }

    root.insertBefore(toc, root.firstChild);
  }

  /* --- FAQ: h3 + 続く要素を <details> アコーディオンへ変換 --- */
  function buildAccordion(root) {
    var questions = [].slice.call(root.querySelectorAll('h3'));

    questions.forEach(function (h3) {
      // h3 の次から、次の h2 / h3 までを回答として収集
      var answerNodes = [];
      var node = h3.nextSibling;
      while (node) {
        if (node.nodeType === 1 && /^H[23]$/.test(node.tagName)) break;
        answerNodes.push(node);
        node = node.nextSibling;
      }
      if (answerNodes.length === 0) return;

      var details = document.createElement('details');
      details.className = 'iic-faq-item';

      var summary = document.createElement('summary');
      var qIcon = document.createElement('span');
      qIcon.className = 'iic-faq-icon';
      qIcon.textContent = 'Q';
      qIcon.setAttribute('aria-hidden', 'true');
      var qText = document.createElement('span');
      qText.textContent = h3.textContent.trim();
      summary.appendChild(qIcon);
      summary.appendChild(qText);

      var answer = document.createElement('div');
      answer.className = 'iic-faq-answer';
      var aIcon = document.createElement('span');
      aIcon.className = 'iic-faq-icon';
      aIcon.textContent = 'A';
      aIcon.setAttribute('aria-hidden', 'true');
      var body = document.createElement('div');
      body.className = 'iic-faq-answer__body';
      answer.appendChild(aIcon);
      answer.appendChild(body);

      details.appendChild(summary);
      details.appendChild(answer);

      h3.parentNode.insertBefore(details, h3);
      h3.parentNode.removeChild(h3);
      answerNodes.forEach(function (n) {
        body.appendChild(n);
      });
    });
  }

  /* --- ガイド: 既存のページ内リンク ul を目次スタイルへ --- */
  function styleGuideToc(root) {
    var firstAnchorLink = root.querySelector('ul a[href^="#link"]');
    if (!firstAnchorLink) return;

    var ul = firstAnchorLink.closest('ul');
    if (!ul) return;

    ul.className = 'iic-toc';
    [].slice.call(ul.querySelectorAll('li')).forEach(function (li) {
      li.className = '';
    });

    // アンカー先 (a[name]) にスクロール余白を付与
    [].slice.call(root.querySelectorAll('a[id^="link_"]')).forEach(function (a) {
      a.style.scrollMarginTop = '120px';
    });
  }

  /* --- ガイド: 「送料について」の <br> 区切りテキストをテーブル化 --- */
  function buildFeeTable(root) {
    var target = null;
    var h3s = root.querySelectorAll('h3');
    for (var i = 0; i < h3s.length; i++) {
      if (h3s[i].textContent.indexOf('送料について') !== -1) {
        target = h3s[i];
        break;
      }
    }
    if (!target) return;

    // h3 の直後から次の要素見出し・段落までの間にあるテキスト/brノードを収集
    var rawNodes = [];
    var node = target.nextSibling;
    while (node) {
      if (node.nodeType === 1 && !/^BR$/.test(node.tagName)) break;
      rawNodes.push(node);
      node = node.nextSibling;
    }

    var lines = [];
    var current = '';
    rawNodes.forEach(function (n) {
      if (n.nodeType === 3) {
        current += n.textContent;
      } else if (n.nodeType === 1 && n.tagName === 'BR') {
        lines.push(current.trim());
        current = '';
      }
    });
    if (current.trim()) lines.push(current.trim());

    var caption = '';
    var notes = [];
    var rows = [];
    lines.forEach(function (line) {
      if (!line) return;
      var m = line.match(/^(.+?)：([\d,]+円[^※]*)$/);
      if (m) {
        rows.push([m[1].trim(), m[2].trim()]);
      } else if (line.charAt(0) === '※') {
        notes.push(line);
      } else if (line.charAt(0) === '【') {
        caption = line.replace(/[【】]/g, '');
      }
    });

    // 解析できなかった場合は何もしない
    if (rows.length < 3) return;

    var frag = document.createDocumentFragment();

    if (caption) {
      var cap = document.createElement('p');
      cap.className = 'iic-fee-caption';
      cap.textContent = caption;
      frag.appendChild(cap);
    }

    var table = document.createElement('table');
    table.className = 'iic-fee-table';
    var thead = document.createElement('thead');
    var headRow = document.createElement('tr');
    ['お届け先', '送料'].forEach(function (label) {
      var th = document.createElement('th');
      th.textContent = label;
      headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    table.appendChild(thead);

    var tbody = document.createElement('tbody');
    rows.forEach(function (row) {
      var tr = document.createElement('tr');
      row.forEach(function (cell) {
        var td = document.createElement('td');
        td.textContent = cell;
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);
    frag.appendChild(table);

    notes.forEach(function (note) {
      var p = document.createElement('p');
      p.className = 'iic-fee-note';
      p.textContent = note;
      frag.appendChild(p);
    });

    // 元のテキスト/br ノードを置き換え
    target.parentNode.insertBefore(frag, rawNodes.length ? rawNodes[0] : target.nextSibling);
    rawNodes.forEach(function (n) {
      if (n.parentNode) n.parentNode.removeChild(n);
    });
  }

  /* --- 特商法: dd 内の「【グループ】」「・箇条書き」「※注記」を改行して読みやすく --- */
  function formatTradelaw(root) {
    [].slice.call(root.querySelectorAll('dd')).forEach(function (dd) {
      if (dd.children.length > 0) return; // テキストのみの dd だけを対象
      var text = dd.textContent;
      if (!/[【※・]/.test(text)) return;

      var esc = text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

      // 全角/半角スペースに続く ・ ※ 【 の直前で改行
      var html = esc.replace(/[\s　]+(?=[・※【])/g, '<br>');
      // 【...】は太字のブロック見出しに
      html = html.replace(/【([^】]*)】/g, '<strong class="iic-dd-group">【$1】</strong>');

      dd.innerHTML = html;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
